/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import {
  Grid,
  Box,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
} from '@mui/material';
import './LeaveEligibilityModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import * as _ from 'lodash';

import { fonts, themes } from '../../../themes/themes';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';
import moment from 'moment';
import { toast } from 'react-hot-toast';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allLeaveTypes: any;
  callBackGetData: (data: any) => void;
  trans: any;
}

const LeaveEligibilityModalPresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  allLeaveTypes,
  trans,
}: ModalProps) => {
  const [note, setNote] = useState('');
  const [leaveValue, setLeaveValue] = useState('leaveAdvance');

  const [, setLeaveType] = useState('');
  const [leaveTypeName, setLeaveTypeName] = useState('');
  const [leaveTypeId, setLeaveTypeId] = useState(0);
  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());
  const [leaveDays, setLeaveDays] = useState<any>();

  const [leaveDocumentFilePath, setLeaveDocumentFilePath] = useState('');
  const [leaveDocumentFile, setLeaveDocumentFile] = useState();
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');

  const handleChange = (event: any) => {
    setLeaveValue(event.target.value);
  };

  const leaveDocumentUpload = (e: any) => {
    const file: any = e.target.files[0];

    if (file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      const image_as_files: any = file;
      setLeaveDocumentFile(image_as_files);
      setLeaveDocumentFilePath(image_as_base64);
    } else {
      setIsPDF(true);
      setPDFName(file?.name);
      setLeaveDocumentFile(file);
    }
  };
  const handleSetLeaveType = (leaveName: any) => {
    const getLeave = _.filter(allLeaveTypes, function (leave: any) {
      return leave.name === leaveName;
    });
    if (getLeave.length) {
      const leave_type = getLeave[0];
      setLeaveType(leave_type?.type);
      setLeaveTypeId(leave_type.id);
      setLeaveTypeName(leaveName);
    }
  };

  const handleEndDate = (value: any) => {
    setEndDate(value);
    if (startDate && value) {
      const diffTime = Math.abs(value - startDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const _formatStartDate = moment(startDate).format('DD-MM-YYYY');
      const _formatEndDate = moment(value).format('DD-MM-YYYY');

      if (startDate < value) {
        setLeaveDays(diffDays + 1);
      } else if (_formatStartDate == _formatEndDate) {
        setLeaveDays(1);
      } else {
        setLeaveDays(0);
      }
    }
  };

  const handleStartDate = (value: any) => {
    setStartDate(value);
    if (endDate && value) {
      const diffTime = Math.abs(endDate - value);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      const _formatStartDate = moment(value).format('DD-MM-YYYY');
      const _formatEndDate = moment(endDate).format('DD-MM-YYYY');
      if (value < endDate || value == endDate) {
        setLeaveDays(diffDays + 1);
      } else if (_formatEndDate == _formatStartDate) {
        setLeaveDays(1);
      } else {
        setLeaveDays(0);
      }
    }
  };
  const handleSubmit = () => {
    const start_date = moment(startDate).format('YYYY-MM-DD');
    const end_date = moment(endDate).format('YYYY-MM-DD');

    if (start_date < end_date || start_date == end_date) {
      callBackGetData({
        leaveValue: leaveValue,
        leaveTypeId: leaveTypeId,
        startDate: start_date,
        endDate: end_date,
        note: note,
        leaveDays: leaveDays,
        file: leaveDocumentFile,
      });
      closeModal();
    } else if (start_date > end_date) {
      toast.error(trans('End date should be greater than start date'));
    }
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="900px"
      modalWidth="444px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Apply Leave Encashment') }}
        closeModal={closeModal}
      />
      <Grid
        container
        style={{
          marginTop: '32px',
        }}
      >
        <Grid item xs={12}>
          <RadioGroup
            name="radio-buttons-group"
            value={leaveValue}
            onChange={handleChange}
          >
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Box className="border-checkBox2">
                  <FormControlLabel
                    value="leaveAdvance"
                    control={
                      <Radio
                        sx={{
                          '&.Mui-checked': {
                            color: themes.primaryMain,
                          },
                        }}
                      />
                    }
                    label={trans('Leave Advance')}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="border-checkBox2">
                  {' '}
                  <FormControlLabel
                    value="leaveEncashment"
                    control={
                      <Radio
                        sx={{
                          '&.Mui-checked': {
                            color: themes.primaryMain,
                          },
                        }}
                      />
                    }
                    label={trans('Leave Encashment')}
                  />
                </Box>
              </Grid>
            </Grid>
          </RadioGroup>
        </Grid>
        {leaveValue == 'leaveEncashment' ? (
          <>
            <Grid item xs={12} style={{ marginTop: '1.5em' }}>
              <CustomTextField
                type="number"
                label={trans('Select Days')}
                placeholder={trans('Select Days')}
                value={leaveDays}
                onChange={(event: any, newValue: any) => {
                  setLeaveDays(newValue);
                }}
              />

              <Typography
                style={{
                  marginTop: '1em',
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.primaryMain,
                  fontStyle: 'italic',
                }}
              >
                {trans('You are Eligible for {{count}} Days Encashment', {
                  count: 5,
                })}
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ marginTop: '1.5em' }}>
              <CustomTextField
                type=""
                label={trans('Note')}
                placeholder={trans('Write Note')}
                value={note}
                onChange={(event: any, newValue: any) => {
                  setNote(newValue);
                }}
              />
            </Grid>
            <Grid item xs={6} style={{ marginTop: '1.5em', flexGrow: 1 }}>
              <DropAndSelect
                upload={leaveDocumentUpload}
                src={leaveDocumentFilePath}
                isPDF={isPDF}
                pdfName={pdfName}
                onDelete={() => {
                  setPDFName('');
                  setIsPDF(false);
                  setLeaveDocumentFilePath('');
                }}
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} style={{ marginTop: '1em' }}>
              <CustomAutoComplete
                label={trans('Leave Type')}
                options={_.map(allLeaveTypes, (leave: any) => {
                  return leave.name;
                })}
                value={leaveTypeName}
                onChange={(event: any, newValue: any) => {
                  handleSetLeaveType(newValue);
                }}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: '1.5em' }}>
              <CustomDatePicker
                label={trans('Start Date')}
                value={new Date(startDate)}
                onChange={(newValue: any) => {
                  handleStartDate(newValue?.$d);
                }}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: '1.5em' }}>
              <CustomDatePicker
                label={trans('End Date')}
                value={new Date(endDate)}
                onChange={(newValue: any) => {
                  handleEndDate(newValue?.$d);
                }}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: '1em' }}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.primaryMain,
                  fontStyle: 'italic',
                }}
              >
                {trans('Total Selected {{count}} Days', { count: leaveDays })}
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ marginTop: '1em' }}>
              <CustomTextField
                type=""
                label={trans('Write Reason')}
                placeholder={trans('Write Reason')}
                value={note}
                onChange={(event: any, newValue: any) => {
                  setNote(newValue);
                }}
              />
            </Grid>
            <Grid item xs={6} style={{ marginTop: '1.5em', flexGrow: 1 }}>
              <DropAndSelect
                upload={leaveDocumentUpload}
                src={leaveDocumentFilePath}
                isPDF={isPDF}
                pdfName={pdfName}
                onDelete={() => {
                  setPDFName('');
                  setIsPDF(false);
                  setLeaveDocumentFilePath('');
                }}
              />
            </Grid>
          </>
        )}
      </Grid>
      <Box style={{ marginTop: '24px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default LeaveEligibilityModalPresenter;
